module.exports = __webpack_public_path__ + "images/emoji/dog2.a425245d58a1cd641adc.png";